import React from "react";

export const RecordingIcon = React.memo(() => {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.5" cy="12.5" r="7.5" fill="#C13314"/>
            <circle cx="12.5" cy="12.5" r="11" stroke="#C13314" strokeWidth="3"/>
        </svg>
    )
});